// extracted by mini-css-extract-plugin
export default {"collapseButton":"Reporting_collapseButton__dssc8","svgIcon":"Reporting_svgIcon__lKnWw"};